import React from "react";
import { CalendarDays, Clock4, MapPin, Pencil, Users2 } from "lucide-react";
import { hoursLabel, sessionLine } from "../../../lib/groupSessions";
import { dayLabel, formatLabel, isHeld, statusLabel } from "../../../lib/groupSheet";

/**
 * The sheet's Program tab: the group's data and its sessions, the held ones
 * marked. „Editează programul” opens the edit window on its schedule tab
 * (decision E), for whoever may edit.
 */
export default function ScheduleTab({ group, onEditSchedule }) {
  const sessions = group.sessions || [];
  const held = sessions.filter((s) => isHeld(s)).length;
  return (
    <div className="space-y-5" data-testid="group-tab-program">
      <section className="grid grid-cols-2 md:grid-cols-3 gap-3 text-sm">
        <Meta icon={<CalendarDays size={14} />} label="Start" value={dayLabel(group.start_date)} />
        <Meta icon={<CalendarDays size={14} />} label="Final" value={dayLabel(group.end_date)} />
        <Meta icon={<MapPin size={14} />} label="Format" value={formatLabel(group.format)} />
        <Meta icon={<Clock4 size={14} />} label="Zile" value={(group.schedule_days || []).join(", ") || "—"} />
        <Meta icon={<Clock4 size={14} />} label="Oră" value={group.schedule_time || "—"} />
        <Meta icon={<Users2 size={14} />} label="Status" value={statusLabel(group.status)} />
      </section>

      <section data-testid="group-details-sessions">
        <div className="flex flex-wrap items-center justify-between gap-2">
          <h3 className="text-xs font-semibold uppercase tracking-widest text-[#6B7280]">
            Sesiuni · {sessions.length} · {hoursLabel(group.session_total_minutes || 0)}
            {held > 0 && ` · ${held} ${held === 1 ? "ținută" : "ținute"}`}
          </h3>
          {onEditSchedule && (
            <button type="button" onClick={onEditSchedule} data-testid="group-edit-schedule"
              className="inline-flex items-center gap-1.5 rounded-full border border-[#E5E7EB] px-3 py-1.5 text-xs font-semibold text-[#373A45] hover:border-[#965EA7] hover:text-[#965EA7]">
              <Pencil size={12} /> Editează programul
            </button>
          )}
        </div>
        {sessions.length === 0 ? (
          <p className="mt-2 text-sm text-[#6B7280]">Grupa nu are încă sesiuni.</p>
        ) : (
          <ol className="mt-2 grid gap-1 text-sm text-[#373A45] sm:grid-cols-2">
            {sessions.map((x, i) => {
              const done = isHeld(x);
              return (
                <li key={`${x.date}-${x.start_time}`} className={`flex gap-2 ${done ? "text-[#6B7280]" : ""}`}>
                  <span className="w-5 shrink-0 text-right tabular-nums text-[#6B7280]">{i + 1}.</span>
                  <span>
                    {sessionLine(x)}
                    {done && <span className="ml-1.5 rounded-full bg-[#EDEEF0] px-1.5 py-0.5 text-[10px] font-semibold text-[#6B7280]">ținută</span>}
                    {x.note && <span className="block text-[11px] font-semibold text-[#7A4986]">{x.note}</span>}
                  </span>
                </li>
              );
            })}
          </ol>
        )}
      </section>
    </div>
  );
}

function Meta({ icon, label, value }) {
  return (
    <div className="rounded-xl bg-[#F5F6F6] border border-[#E5E7EB] px-3 py-2.5">
      <div className="text-[10px] uppercase tracking-widest text-[#6B7280] font-semibold inline-flex items-center gap-1">
        {icon} {label}
      </div>
      <div className="mt-1 text-sm text-[#373A45]">{value || "—"}</div>
    </div>
  );
}
